import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { bootstrapAuth } from '../../redux/reducers/AuthReducer';

/**
 * Guard con bootstrap:
 * - Si `ready` es false, dispara bootstrapAuth() una sola vez (idempotente)
 *   para validar sesión vía /auth/me y no pinta nada (loader lo gestiona App).
 * - Si `ready` es true y no hay usuario, redirige a /.
 * - Si hay usuario, renderiza la ruta hija (<Outlet/>).
 */
export function PrivateRoute() {
  const dispatch = useDispatch();
  const { ready, user } = useSelector((s) => s.auth || {});
  const location = useLocation();

  useEffect(() => {
    if (!ready) dispatch(bootstrapAuth());
  }, [ready, dispatch]);

  if (!ready) return null; // deja que App muestre el loader
  if (!user)  return <Navigate to="/" replace state={{ from: location }} />;

  return <Outlet />;
}

// Export por compatibilidad con tu import en AppRoutes
export { RoleRouteGuard } from './RoleRouteGuard';
export { PrivateRoute as default };
